module.exports = __webpack_public_path__ + "img/describe.c5328591.png";